export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00074.984c46ca.png";